/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { getFeatureFlag } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { Tabs, Tab, AppBar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
   appBar: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.palette.borderRadius,
    color: 'black',
    boxShadow: 'none!important',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: `1px solid ${theme.palette.thankyoucards.separator}`,
    borderBottom: `1px solid ${theme.palette.thankyoucards.separator}`,
  },
  tabIndicator: {
    backgroundColor: theme.palette.thankyoucards.underlineColor,
    height: '3px'
  },
  tab: {
   fontSize: '14px',
   textTransform: 'capitalize',
   opacity: 1,
   '&.Mui-selected': {
      fontWeight: '700',
   },
  },
  tabs: {
   fontSize: '11px', 
   width: '100%',
   display: 'flex',
   justifyContent: 'center',
   "& .mbp-account-MuiTabs-scroller": {
      display: "flex",
      justifyContent: "center"
    },
   "& .mbp-account-MuiTab-root": {
      fontFamily: theme.palette.thankyoucards.typography
   }
  }
}));


const RecipientNavigationBar = ({ handleChange, tabValue, ...props }) => {
   const classes = useStyles();
   // Turns the whats inside tab - ON/OFF
   const isWhatsInsideTabEnabled = useSelector(getFeatureFlag('is-showing-whats-inside-tab'));
   const isFlowerCareTabEnabled = useSelector(getFeatureFlag('is-flower-care-tab-enabled'));

   const a11yProps = (index) => {
      return {
         id: `vertical-tab-${index}`,
         'aria-controls': `vertical-tabpanel-${index}`,
      };
   };

   const renderTabs = () => {
      const tabs = [
        <Tab disableRipple key="Your Message" className={classes.tab} label="Your Message" />,
        isWhatsInsideTabEnabled && <Tab disableRipple key="What's Inside" className={classes.tab} label="What's Inside" />,
        isFlowerCareTabEnabled && props.isProductBrand18F && <Tab disableRipple key="Flower Care" className={classes.tab} label="Flower Care" />,
        <Tab disableRipple key="Pay It Forward" className={classes.tab} label="Pay It Forward" />,
      ].filter(Boolean);

      return tabs.map((tab, index) => {
        return React.cloneElement(tab, {
          ...tab.props,
          ...a11yProps(index),
        });
      });
   };
    

  return (
   <>
      <AppBar position="static" className={classes.appBar}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          aria-label="Vertical tabs"
          variant="scrollable"
          scrollButtons="auto"
          className={classes.tabs}
          classes={{ indicator: classes.tabIndicator }}
        >
         {renderTabs()}
        </Tabs>
      </AppBar>
   </>
  )
}

export default RecipientNavigationBar;